// src/business-types/saloon/modules/orders/saloon-order-display/components/OrderActions.tsx
import React from "react";
import { Box } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";
import { Order } from "src/shared/services/interfacev2";

interface Props {
  order: Order;
  onOpenPayment: () => void;
  onOpenCancel: () => void;
}

const OrderActions: React.FC<Props> = ({ order, onOpenPayment, onOpenCancel }) => {
  if (order.orders[0].status === "Cancelled") return null;

  return (
    <Box display="flex" justifyContent="flex-end" gap={2} className="no-print ">
      <CommonButtons className="w-48" label="Cancel Order" variant="outlineDanger" onClick={onOpenCancel} disabled={order.orders[0].status !== "Confirm"}/>
      {/* <Button
        variant="outlined"
        color="error"
        size="large"
        sx={{ px: 4, borderRadius: "8px" }}
        onClick={onOpenCancel}
        disabled={order.OrderStatus !== "Confirm"}
      >
        Cancel Order
      </Button> */}

      {order.orders[0].status === "Confirm" ? (
        <CommonButtons className="w-52 " label="Process Payment" onClick={onOpenPayment}/>
       
      ) : (
        <CommonButtons className="w-52" label="Delivered" disabled/>
      )}
    </Box>
  );
};

export default OrderActions;
